import React from "react";
import { Card, Col, Row } from "antd";
import {
  CreditCardOutlined,
  DollarOutlined,
  FolderOutlined,
  TeamOutlined
} from "@ant-design/icons";
import DoctorListDesboard from "./DoctorList";
import PatientsListDesboard from "./PatientsList";
import AppointmentList from "./AppointmentList";
import LineChart from "./LineChart";
import StatusCharts from "./StatusCharts";
// Hero and KPI tiles share the service-provider dashboard styles.
import "../../../serviceProvider/components/dashboard/Dashboard.css";
import "./SubadminDashboard.css";

import { useTranslation } from "react-i18next";

// The shell (PanelsHeader) already renders the page title, breadcrumb and navigation.
const Dashboard = () => {
  const { t } = useTranslation("dashboard");

  const widgets = [
    {
      key: "clients",
      label: t("Clients"),
      value: "168",
      icon: <TeamOutlined />,
      tone: "brand"
    },
    {
      key: "buyers",
      label: t("Buyers"),
      value: "487",
      icon: <CreditCardOutlined />,
      tone: "green"
    },
    {
      key: "appointments",
      label: t("Appointment"),
      value: "485",
      icon: <DollarOutlined />,
      tone: "violet"
    },
    {
      key: "revenue",
      label: t("Revenue"),
      value: "$62523",
      icon: <FolderOutlined />,
      tone: "amber"
    }
  ];

  return (
    <div className="sp-dashboard subadmin-dashboard">
      <section className="sp-dashboard__hero">
        <div className="sp-dashboard__hero-text">
          <h2>{t("Welcome Admin!")}</h2>
        </div>
      </section>

      <Row gutter={[12, 12]} className="sp-dashboard__row">
        {widgets.map(w => (
          <Col xs={12} xl={6} key={w.key}>
            <Card className={`sp-dashboard__kpi sp-dashboard__kpi--${w.tone}`}>
              <span className="sp-dashboard__kpi-icon">{w.icon}</span>
              <div className="sp-dashboard__kpi-title">{w.label}</div>
              <div className="sp-dashboard__kpi-value">{w.value}</div>
            </Card>
          </Col>
        ))}
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card title={t("Revenue")} className="subadmin-dashboard__card">
            <LineChart />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title={t("Status")} className="subadmin-dashboard__card">
            <StatusCharts />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <DoctorListDesboard />
        </Col>
        <Col xs={24} lg={12}>
          <PatientsListDesboard />
        </Col>
      </Row>

      <AppointmentList />
    </div>
  );
};

export default Dashboard;
